import React, { useEffect, useState } from "react";
import { FileBox, Folder, Gauge, Users } from "lucide-react";
import { useUser } from "@/app/context/UserContext";
import { getUsedProjectCuota } from "@/app/helpers/functions";
import { AlertType } from "@/app/constants/enums";
export default function QuotaProject() {
    const {userProject,setUserProject,addAlert } = useUser(); 
    const [quota, setQuota] = useState<number>(0);
    const [usedPorcentaje, setUsedPorcentaje] = useState<number>(0);
    const [error, setError] = useState<string | null>(null);

    
    const usedQuota=()=>{
        const usedQuotas = getUsedProjectCuota(userProject);
        const percentage = userProject?.project?.quota>0 && usedQuotas > 0
                ? ((usedQuotas / userProject?.project?.quota) * 100)
                : 0;
            setUsedPorcentaje(percentage)
    }
    useEffect(() => {
        usedQuota()
    }, [userProject?.project?.quota, userProject?.project?.users, userProject?.project?.groups ]);
    useEffect(() => {
        if (userProject?.project?.quota !== undefined) {
            setQuota(userProject.project.quota);
        }
    }, []); // Solo al montar
    
    
    const handleQuotaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = Number(e.target.value); 
        const usedQuotas = getUsedProjectCuota(userProject)
        let errorVal = false;
        if(value < usedQuotas){
            setError("La cuota debe ser mayor o igual a la suma de las cuotas asignadas a usuarios y grupos ($ "+ usedQuotas.toFixed(2)+").") 
            errorVal = true;
        } 
        if(value<0){
            setError("La cuota debe ser mayor a cero");
            errorVal = true;
        }
        const domainQuota = userProject?.project?.quota_config?.domain_quota ?? 0;
        const totalProjectQuota = userProject?.project?.quota_config?.total_quota_project_domain ?? 0;
        const maxQuotaAllowed = domainQuota - totalProjectQuota;
        if (value > maxQuotaAllowed) {
            setError(`La cuota debe ser menor o igual a $ ${maxQuotaAllowed.toFixed(2)}.`);
            errorVal = true; 
        }
        
        if(errorVal){
            addAlert( `En caso de no modificar, se almacenará el siguiente valor de cuota: $ ${usedQuotas.toFixed(2)} para el proyecto.`,
                    AlertType.Warning
                    );
        }

        if (value >= 0) { 
            const prevDomainQuota = userProject?.project?.quota_config?.total_quota_project_domain ?? 0;
            const finalDomainQuota = prevDomainQuota + value;
            
            setQuota(value);
            setUserProject({
                ...userProject,
                project: {
                    ...userProject.project, 
                    quota_project_domain: finalDomainQuota,
                    quota: value<usedQuotas || value > maxQuotaAllowed?usedQuotas:value,
                },
            }); 
                
        }
        if(!errorVal)
            setError("")
    };

    if (userProject?.project?.quota === undefined) {
        return <p className="text-gray-500">Cargando cuota...</p>;
    }

    return (

        <div className="flex items-center gap-4">
        <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-blue-100">
            <FileBox className="w-6 h-6 text-blue-600" strokeWidth={1.5} />
        </div>
        <div className="flex-1">
            <h2 className="text-lg font-semibold text-gray-800">Proyecto: {userProject.project.project_name}</h2>
            <div className="mt-1 flex items-center gap-2 text-sm text-gray-600">
                <Gauge className="w-4 h-4 text-blue-500" />
                <span>Cuota asignada:</span>
                <div className=" relative w-6/12"> 
                    <span className="absolute left-2 top-1/2 -translate-y-1/2 text-gray-500"> $ </span>  
                    <input
                        type="number"
                        step="0.01"
                        value={quota}
                        onChange={handleQuotaChange}
                        className="w-full pl-6 border n-fmr-input px-3 py-2 border-gray-300 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-700 text-right"
                        />
                </div> 
            </div>
            {/* Barra de progreso */}
            <div className="mt-2 h-2 w-full rounded-full bg-gray-200">
                <div
                    className={`h-2 rounded-full transition-all duration-300 ${usedPorcentaje > 100 ? "bg-red-500" : "bg-blue-500"}`}
                    style={{ width: `${usedPorcentaje>100?100:usedPorcentaje}%` }}
                />
                </div> 
                {error && <p className="text-red-500 text-sm">{error}</p>}
            </div>
            
        </div>

    );
}
